module.exports = __webpack_public_path__ + "static/media/place-holder.b1cf7145.png";